import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { throttle } from 'lodash';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { trackPageName } from 'modules/taboola-common-frontend-modules/gtmTracker/urlPageNameService';
import { getPageName, isInterimPageName } from 'modules/taboola-common-frontend-modules/gtmTracker/urlPageNameUtil';

const DEFAULT_THROTTLE_TIME = 200;

const throttledUpdatePageName = throttle(
    ({ pathname, search, setPageName }) => {
        const newPageName = getPageName({ pathname, search });
        setPageName(newPageName);
    },
    DEFAULT_THROTTLE_TIME,
    { leading: false, trailing: true }
);

export const usePageName = () => {
    const { accountId } = useAccount();
    const location = useLocation();
    const { pathname, search } = location;
    const [pageName, setPageName] = useState(getPageName({ pathname, search }));

    useEffect(() => {
        throttledUpdatePageName({ pathname, search, setPageName });

        return () => {
            throttledUpdatePageName.cancel();
        };
    }, [pathname, search]);

    useEffect(() => {
        if (isInterimPageName(pageName) || !accountId) {
            return;
        }
        trackPageName(pageName, accountId);
    }, [pageName, accountId]);

    return pageName;
};

export default usePageName;
